import React from "react";
import debugx from "debugx";

const debug = debugx("bikedash:settings");

export interface ToggleSwitchProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
}

export const ToggleSwitch: React.FC<ToggleSwitchProps> = ({
  checked,
  onChange,
}) => {
  return (
    <button
      className={`toggle-button ${checked ? "checked" : ""}`}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        debug("Toggle clicked:", "current:", checked, "new:", !checked);
        onChange(!checked);
      }}
      type="button"
      style={{ cursor: "pointer", zIndex: 9999, position: "relative" }}
    >
      <div className="toggle-slider" style={{ pointerEvents: "none" }} />
    </button>
  );
};
